<template>
    <div>
        <MainLayout>
            <div class="home-content">
                <div class="home">
                    <h1>{{ $t('home_title') }}</h1>
                </div>
            </div>
        </MainLayout>
    </div>
</template>

<script>
    import MainLayout from '../components/MainLayout.vue';

    export default {
        name: 'home',
        components: {
            MainLayout,
        }
    }
</script>

<style scoped>
</style>
